<template>
  <div class="school-uniform-loan">
    <h1>Cash Box Credit Union School Uniform Loan <span class="d-block small">Borrow up to &pound;600</span></h1>
    <p>
      The Cash Box Credit Union School Uniform Loans lets you borrow to help with the cost of school uniforms and use your child benefit to cover the repayments.
    </p>
    <b-img fluid src="/alerts/school-uniform.jpg" alt="School Uniform"
           class="d-block mx-auto p-0 rounded float-md-right pl-md-3 col-12 col-sm-8 col-md-5 mb-4" />
    <h3>How do I qualify?</h3>
    <p>
      Below are the simple requirements to apply for our credit union School Uniform Loan.
    </p>
    <ul>
      <li>Be aged 18 years old or over.</li>
      <li>
        In receipt of child benefit payments and agree to have this paid into your
        Cash Box Credit Union account until your loan is repaid.
      </li>
      <li>
        Live or work in Tameside & Glossop.
      </li>
    </ul>
    <p>
      If you meet the above criteria, then our application process is very simple!
    </p>

    <h3>How much could I apply for?</h3>
    <div class="mb-3">
      <b-table
          outlined
          thead-class="bg-success text-white"
          class="mt-3 mb-0"
          :items="table.items"
          :fields="table.fields"
          responsive
          stacked="sm"
      />
    </div>

    <h3>How do I apply?</h3>
    <p>Whether you’re already a member or thinking of becoming part of our credit union community, we welcome your application.</p>
    <div class="d-flex flex-column flex-md-row mb-3" style="gap:0.5rem;">
      <a href="https://cashbox.cuaccount.com/login/" target="_blank" class="btn btn-primary">Existing Members - Apply Here</a>
      <a href="https://cashbox.cuaccount.com/join/" target="_blank" class="btn btn-success">New Members</a>
    </div>
    <p>
      The repayments can be arranged to suit what you can afford to pay.
    </p>
    <p>
      You decide how much of your child benefit is placed into your savings account, subject to a minimum of £2 per week.
    </p>
    <p>
      If you still have money left from your child benefit, after repaying your loan and paying into your savings, we can return an amount to you by lunch time on the day that we receive your child benefit.
    </p>

    <h3>What other benefits does the Cash Box Credit Union have?</h3>
    <ul>
      <li>Our members are our family</li>
      <li>All applications are looked at by real people, not a computer</li>
      <li>The interest rate is fixed for the term of the loan</li>
      <li>No setup or early repayment fees</li>
      <li>Each payment you make adds a little more to your savings</li>
      <li>
        A loan with your local credit union will help you build or repair your
        credit rating
      </li>
    </ul>

    <p>
      If you need more information on our credit union School Uniform Loan, please contact
      our friendly staff on 0161 342 3266 or by emailing
      <a href="mailto:enquiries@cashbox.org.uk">enquiries@cashbox.org.uk</a>.
    </p>

    <hr />
    <p>
      Credit Unions are financial community co-operatives that promote savings as
      well as loans.
    </p>
    <p>
      Members of the credit union pool their savings to provide the funds from
      which loans are made. The interest on loans pays for the running of the
      credit union and if there is a surplus, members get a share of the profit
      known as a dividend.
    </p>
    <p>
      We expect all of our members to save as much as they can afford, even if
      they are repaying a loan. As a minimum, we would expect you to save at least
      £2 per week/£10 per month and keep this in your savings account while you
      have a loan outstanding with us. Once your savings balance is higher than
      your loan balance, you may if you wish withdraw the difference.
    </p>
  </div>
</template>

<script>
export default {
  name: 'SchoolUniformLoan',
  metaInfo() {
    return {
      title: 'Upto £60 Credit Union School Uniform Loan | Cash Box Credit Union',
      meta: [
        { name: 'keywords', content: "Credit, Union, School Uniform, Loan" },
        { name: 'description', content: "£600 Credit Union School Uniform Loan" }
      ],
    };
  },
  data() {
    return {
      table: {
        items: [
          { children: "1 Child", amount: 150 },
          { children: "2 Children", amount: 300 },
          { children: "3 Children", amount: 450 },
          { children: "4+ Children", amount: 600 },
        ],
        fields: [
          { key: "children", label: "Number of Children (must be school age)" },
          { key: "amount", label: "Loan Amount", formatter: (value) => `£${value.toLocaleString('en-GB')}` }
        ]
      }
    }
  }
}
</script>

<style scoped>

</style>
